import InsertAnswer from './InsertAnswer'
import AutoNumber from './AutoNumber'
import SubmitTime from './SubmitTime'
import FixedChar from './FixedChar'

const components = {
  SubmitTime,
  AutoNumber,
  FixedChar,
  InsertAnswer
}

export default components
